<template>
    <vertical-form-table v-model="form" v-bind="{ mode, items }" @input="emit"> </vertical-form-table>
</template>

<script>
import VerticalFormTable from "@/components/dumb/vertical-form-table.vue";
import VImagesTileField from "@/components/plugins/vuetify/v-images-tile-field.vue";

export default {
    components: {
        VerticalFormTable,
        VImagesTileField,
    },
    props: {
        value: { type: Object, default: () => ({}) }, // form
        mode: { type: String, default: "view" },
    },
    data: () => ({
        form: {},
    }),
    computed: {
        items() {
            let items = [
                {
                    key: "introduction.images",
                    term: "이미지",
                    type: "images-tile",
                    props__input: {
                        cols: "4",
                        md: "2",
                        lg: "auto",
                    },
                },
                {
                    key: "introduction.content",
                    term: "소개글",
                    type: "textarea",
                },
            ];
            return items.map((item) => ({ ...item, outlined: true }));
        },
    },
    mounted() {
        this.sync();
    },
    watch: {
        value() {
            this.sync();
        },
    },
    methods: {
        sync() {
            this.form = { ...this.value };
        },
        emit() {
            this.$emit("input", this.form);
        },
    },
};
</script>

<style>
</style>